import { render, staticRenderFns } from "./OverDueReport.vue?vue&type=template&id=6537ac3a"
import script from "./OverDueReport.vue?vue&type=script&lang=js"
export * from "./OverDueReport.vue?vue&type=script&lang=js"
import style0 from "./OverDueReport.vue?vue&type=style&index=0&id=6537ac3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports